import { useState } from 'react';

import { SecondaryButton } from '@atoms/buttons/SecondaryButton';
import { DownloadIcon } from '@atoms/Icon/DownloadIcon';

import { CREATE_STATEMENT_BUTTON_TEST_ID } from './constants';
import { CreateStatementDialog } from './CreateStatementDialog';

interface Props {
  accountNumber: string;
}

export const CreateStatementButton = ({ accountNumber }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-col gap-4">
      <SecondaryButton
        data-testid={CREATE_STATEMENT_BUTTON_TEST_ID}
        onClick={() => setOpen(true)}
        className="h-9"
      >
        <DownloadIcon className="size-4 stroke-current text-content-brand" />
        Export
      </SecondaryButton>
      <CreateStatementDialog
        open={open}
        onClose={() => setOpen(false)}
        accountNumber={accountNumber}
      />
    </div>
  );
};
